/**
 * @description: 平台票核验汇总报表
 * @author: hwx
*/
<template>
    <div class="tsr-pyh-report">
        <div class="pyh-list">
            <el-form :inline="true" size="small" :model="pyh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="pyh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="pyh_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="pyh_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="pyh_list_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台票类型">
                    <el-select v-model="pyh_list_form.relation_type" filterable clearable placeholder="请选择平台票类型">
                        <el-option v-for="item in platform_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台票名称">
                    <el-input placeholder="请输入平台票名称" v-model="pyh_list_form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getPyhList(1)">查询</el-button>
                    <el-button @click="pyhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="pyh_list">
                <el-table-column prop="relation_type_name" label="平台票类型"></el-table-column>
                <el-table-column prop="relation_name" label="平台票名称"></el-table-column>
                <el-table-column prop="discount_price" label="平台票价格"></el-table-column>
                <el-table-column prop="settlement_price" label="平台结算价"></el-table-column>
                <el-table-column prop="quantity" label="数量"></el-table-column>
                <el-table-column prop="total_settlement_price" label="平台结算总额"></el-table-column>
                <el-table-column prop="ticket_price" label="门票收入"></el-table-column>
                <el-table-column prop="a_price" label="A类酒水收入"></el-table-column>
                <el-table-column prop="b_price" label="B类酒水收入"></el-table-column>
                <el-table-column prop="c_price" label="C类酒水收入"></el-table-column>
                <el-table-column prop="d_price" label="D类酒水收入"></el-table-column>
                <el-table-column prop="time_price" label="房费收入"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-3">总数量:</label>
                    <div class="list-total">{{pyh_quantity}}</div>
                    <label class="list-label-6">平台结算总额:</label>
                    <div class="list-total">{{pyh_settlement_price}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="pyh_list_page"
                    :total="pyh_list_total"
                    @current-change="getPyhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="pyh_list_export">
                <h2>请选择导出报表需要的显示的字段</h2>
                <el-checkbox :indeterminate="pyh_export_sign" v-model="pyh_export_all" @change="pyhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="pyh_export_ids" @change="pyhExportChange">
                    <el-checkbox label="relation_type_name">平台票类型</el-checkbox>
                    <el-checkbox label="relation_name">平台票名称</el-checkbox>
                    <el-checkbox label="discount_price">平台票价格</el-checkbox>
                    <el-checkbox label="settlement_price">平台结算价</el-checkbox>
                    <el-checkbox label="quantity">数量</el-checkbox>
                    <el-checkbox label="total_settlement_price">平台结算总额</el-checkbox>
                    <el-checkbox label="ticket_price">门票收入</el-checkbox>
                    <el-checkbox label="a_price">A类酒水收入</el-checkbox>
                    <el-checkbox label="b_price">B类酒水收入</el-checkbox>
                    <el-checkbox label="c_price">C类酒水收入</el-checkbox>
                    <el-checkbox label="d_price">D类酒水收入</el-checkbox>
                    <el-checkbox label="time_price">房费收入</el-checkbox>
                </el-checkbox-group>
                <h2>请选择导出报表的文件格式</h2>
                <el-radio v-model="pyh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="pyh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                platform_list: [],
                pyh_list_form: {
                    start_time: moment().subtract(1, 'day').format('YYYY-MM-DD 08:00'),
                    end_time: moment().format('YYYY-MM-DD 08:00'),
                    shop_id: '',
                    relation_type: '',
                    name: ''
				},
                pyh_quantity: '',
                pyh_settlement_price: '',
				pyh_list: [],
				pyh_list_page: 1,
                pyh_list_total: 0,
                pyh_export_sign: false,
				pyh_export_all: false,
                pyh_export_ids: [],
                pyh_export_list: ['relation_type_name', 'relation_name', 'discount_price', 'settlement_price', 'quantity', 'total_settlement_price', 'ticket_price', 'a_price', 'b_price', 'c_price', 'd_price', 'time_price'],
                pyh_export_type: '1',
            }
        },
        mounted: function() {
            this.initDate()
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.pyh_list_form.shop_id = this.shop_list[0].id
                this.getTicketPlatform()
                this.getPyhList(1)
            })
        },
        methods: {
            // 初始化日期插件
            initDate: function() {
                const _this = this
                $(_this.$refs.pyh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.pyh_list_form.start_time = start.format('YYYY-MM-DD 08:00')
                    _this.pyh_list_form.end_time = end.format('YYYY-MM-DD 08:00')
                })
            },
            // 门店
            getShop: function(resolve) {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 平台票类型
            getTicketPlatform() {
                const _this = this;

                Vue.axios.post('PublicData/api_getTicketGroup', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.platform_list = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },



            getPyhList(page) {
				const _this = this;

				_this.loading = true
                _this.pyh_list_page = page
				Vue.axios.post('TicketOrder/getTicketGroupCountList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.pyh_list_form.start_time,
                            "end_time": _this.pyh_list_form.end_time,
							"shop_id": _this.pyh_list_form.shop_id,
							"relation_type": _this.pyh_list_form.relation_type,
							"name": _this.pyh_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.pyh_list_total = Number(res.data.response.result.total_data.total)
							_this.pyh_quantity = res.data.response.result.total_data.quantity
							_this.pyh_settlement_price = res.data.response.result.total_data.settlement_price
						}
						_this.pyh_list = res.data.response.result.rows
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 导出
            pyhExportAll(val) {
				this.pyh_export_ids = val ? this.pyh_export_list : [];
				this.pyh_export_sign = false;
			},
			pyhExportChange(val) {
				const len = val.length;
				this.pyh_export_all = len === this.pyh_export_list.length;
				this.pyh_export_sign = len > 0 && len < this.pyh_export_list.length;
			},
            pyhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "TicketOrder/exportGroupCountList"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.pyh_export_ids = res.data.response.result.export_fields;
                            _this.pyh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.pyh_export_ids = _this.pyh_export_list;
                            _this.pyh_export_type = '1';
                        }
                        _this.pyhExportChange(_this.pyh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.pyh_list_export)
                }, function() {
                    _this.pyhExport();
                });
            },
            pyhExport: function() {
                window.location.href = Vue.ctUrl + "TicketOrder/exportGroupCountList" +
                    "?start_time=" + this.pyh_list_form.start_time +
                    "&end_time=" + this.pyh_list_form.end_time +
                    "&shop_id=" + this.pyh_list_form.shop_id +
                    "&relation_type=" + this.pyh_list_form.relation_type +
                    "&name=" + this.pyh_list_form.name +
                    "&export_fields=" + JSON.stringify(this.pyh_export_ids) +
                    "&export_type=" + this.pyh_export_type
                layer.closeAll()
                layer.msg("导出成功！")
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        h2 {
            margin: 20px 0 15px 0;
            font-size: 16px;
        }
    }
</style>